import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dropdown} from "primereact/dropdown";
import {InputTextarea} from "primereact/inputtextarea";
import {Checkbox} from "primereact/checkbox";
import Message from "../Helpers/Message.js";
import {fetch_url_post} from "../../Sources/js/app.js";

let oper="";

let defaultInputValues={
	id: null,
	name: "",
	observations: "",
};

let defaultInputValuesProducts={
	id: null,
	product_id: 0,
	product_mu_id: "",
	filter_products: "",
	product_type_id: 0,
	filter_product_type: "",
	observations: "",
	sub_agreements_id: 0,
	filter_invalid: 0,
};

let defaultDataValues={
	templateProductsList: [],
	productsList: [],
	MUsList:[],
	productsTypesList: [],
	subAgreementsList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
	openListProducts: false,
	titleListProducts: "",
	openAddEditProduct: false,
	titleAddEditProduct: "",
};

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let currentTemplate={};

const MonthlyRequestsTemplates = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.centerId?props.productId:null);

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [inputValuesProducts, setInputValuesProducts] = useState(defaultInputValuesProducts);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [templateProductsList, setTemplateProductsList] = useState([]);
	const [productsList, setProductsList] = useState([]);
	const [unitaryPrice, setUnitaryPrice] = useState("");
	const [availableQuantity, setAvailableQuantity] = useState("");
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="name") {
			let found=false;
			if(dataValues.templatesList.length>0) {
				dataValues.templatesList.forEach(element => {
					if(value===element.name) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un sablon cu acest nume!":""),
			}
			setInputError(tmp);
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleChangeProducts = evt => {
		const {name, value} = evt.target;
		let state_update=0;
		if(name==="product_id") {
			let tmp=dataValues.productsList.filter((product)=>(product.id===value));
			if(tmp.length>0) {
				setInputValuesProducts({...inputValuesProducts,product_mu_id:tmp[0].product_mu_id,
																product_type_id: tmp[0].product_type_id,
																product_id:value
				});
				state_update=1;
				let found=false;
				if(dataValues.templateProductsList.length>0) {
					dataValues.templateProductsList.forEach(element => {
						if((value===element.product_id)&&(tmp[0].product_mu_id===element.product_mu_id)) {
							found=true;
						}
					});
				}
				tmp={
					disableSave: found,
					errorText: (found===true?"Exista deja un produs similar adaugat!":""),
				}
				setInputError(tmp);
			}else{
				state_update=true;
				setInputError(defaultInputError);
				setInputValuesProducts(defaultInputValuesProducts);
			}
			setDataValues({...dataValues,subAgreementsList:[]});							
		}
		if(name==="product_mu_id") {
			//reset sub agreement values
			setDataValues({...dataValues,subAgreementsList:[]});										
			setAvailableQuantity("");
			setUnitaryPrice("");
			let found=false;
			if(dataValues.templateProductsList.length>0) {
				dataValues.templateProductsList.forEach(element => {
					if((value===element.product_mu_id)&&(inputValuesProducts.product_id===element.product_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un produs similar adaugat!":""),
			}
			setInputError(tmp);
			state_update=1;
			setInputValuesProducts({...inputValuesProducts,sub_agreements_id:0,[name]:value});
		}
		if(name==="filter_products") {
			setTemplateProductsList(dataValues.templateProductsList.filter((product)=>((product.product_name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value===""))
																	.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")||(!inputValuesProducts.filter_product_type)))
																	.filter((product)=>(((inputValuesProducts.filter_invalid?product.sub_agreements_id===0:true))))
			);
		}
		if(name==="product_type_id") {
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value))));
		}
		if(name==="filter_product_type") {
			setTemplateProductsList(dataValues.templateProductsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value)))
																	.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1))||(inputValuesProducts.filter_products===""))
																	.filter((product)=>(((inputValuesProducts.filter_invalid?product.sub_agreements_id===0:true))))
			);
		}
		if((name==="unitary_price")||(name==="min_quantity")||(name==="max_quantity")) {
			if(!evt.target.validity.valid) {
				setMessageText("Eroare: Sunt permise numai cifre!");							
				return false;
			}
		}
		if(name==="sub_agreements_id") {
			dataValues.subAgreementsList.forEach(function(agreement) {
				if(agreement.sub_agreement_id===value) {
					setAvailableQuantity(agreement.quantity);
					setUnitaryPrice(agreement.unitary_price);					
				}
			});
		}
		if(name==="filter_invalid") {
			setInputValuesProducts({...inputValuesProducts,[name]:(evt.checked?1:0)});
			setTemplateProductsList(dataValues.templateProductsList.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1))||(inputValuesProducts.filter_products===""))
																	.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")||(!inputValuesProducts.filter_product_type)))
																	.filter((product)=>(((evt.checked?product.sub_agreements_id===0:true))))
			);
			state_update=1;
		}
		if(!state_update) {
			setInputValuesProducts({...inputValuesProducts,[name]:value});
		}
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare sablon"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			setInputValues(elementData);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare sablon "+elementData.name});
			setInputError(defaultInputError);
		}
		if(what==="delete") {
			let url="deleteMonthlyRequestTemplate";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValues.name) {
				setMessageText("Eroare: Completati numele sablonului!");				
				document.getElementById("name").classList.add("required_input_error");
				return false;
			}
			let url="saveMonthlyRequestTemplate";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="list_products") {
			let url="getMonthlyRequestTemplateProducts";
			url+="?session_id="+props.session.sessId;
			oper="list_products";
			let data={
				monthly_requests_template_id: elementData.id,
			};
			currentTemplate=elementData;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="add_product") {
			setProductsList(dataValues.productsList);
			setInputValuesProducts(defaultInputValuesProducts);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Adaugare produs nou"});
			setInputError(defaultInputError);
			setAvailableQuantity("");
			setUnitaryPrice("");
			setDataValues({...dataValues,subAgreementsList:[]});							
		}
		if(what==="edit_product") {
			let tmp={...elementData};
			tmp.filter_products=inputValuesProducts.filter_products;
			tmp.filter_product_type=inputValuesProducts.filter_product_type;
			tmp.sub_agreements_id=0;
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===elementData.product_type_id)||(elementData.product_type_id==="")||(!elementData.product_type_id))));			
			setInputValuesProducts(tmp);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Editare produs "});
			setInputError(defaultInputError);
			setAvailableQuantity("");
			setUnitaryPrice("");
			setDataValues({...dataValues,subAgreementsList:[]});							
		}
		if(what==="delete_product") {
			let url="deleteMonthlyRequestTemplateProduct";
			url+="?session_id="+props.session.sessId;
			oper="delete_product";
			let data={
				id: elementData.id,
				monthly_requests_template_id: currentTemplate.id,
				product_id: elementData.product_id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_product") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValuesProducts.product_id) {
				setMessageText("Eroare: Alegeti un produs din lista!");				
				document.getElementById("product_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.product_mu_id) {
				setMessageText("Eroare: Alegeti o unitate de masura!");				
				document.getElementById("product_mu_id").classList.add("required_input_error");
				return false;
			}
			let url="saveMonthlyRequestTemplateProduct";
			url+="?session_id="+props.session.sessId;
			oper="save_product";
			let data={...inputValuesProducts};
			data.monthly_requests_template_id=currentTemplate.id;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="find_contract") {
			let url="findSubAgreementByProduct";
			url+="?session_id="+props.session.sessId;
			oper="find_contract";
			let data={
				product_id: inputValuesProducts.product_id,
				product_mu_id: inputValuesProducts.product_mu_id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")) {
			if(oper==="get") {
				setDataValues({...dataValues,
											templatesList:(result.templatesList?result.templatesList:[]),
											providersList:(result.providersList?result.providersList:[]),
											productsList:(result.productsList?result.productsList:[]),
											MUsList:(result.MUsList?result.MUsList:[]),
											productsTypesList:(result.productsTypesList?result.productsTypesList:[])
				});
			}else{
				setDataValues({...dataValues,templatesList:(result.templatesList?result.templatesList:[])});
			}
			setDialogValues(defaultDialogValues);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if((oper==="list_products")||(oper==="save_product")||(oper==="delete_product")) {
			setDataValues({...dataValues,templateProductsList:(result.templateProductsList?result.templateProductsList:[])});							
			setInputValuesProducts(defaultInputValuesProducts);
			setTemplateProductsList(result.templateProductsList?result.templateProductsList
																					.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1))||(inputValuesProducts.filter_products===""))
																					.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")))
			:[]);
			setDialogValues({...dialogValues,
											openListProducts: true, titleListProducts: "Lista produse sablon "+currentTemplate.name,
											openAddEditProduct: false,titleAddEditProduct: ""
			});
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if(oper==="find_contract") {
			setDataValues({...dataValues,subAgreementsList:(result.subAgreementsList?result.subAgreementsList:[])});							
			if(!result.subAgreementsList.length) {
				let tmp={
					disableSave: true,
					errorText: "Nu exista un contract asociat!",
				}
				setInputError(tmp);
			}else{
				if(result.subAgreementsList.length===1) {
					setInputValuesProducts({...inputValuesProducts,sub_agreements_id:result.subAgreementsList[0].sub_agreement_id,});							
					setAvailableQuantity(result.subAgreementsList[0].quantity);
					setUnitaryPrice(result.subAgreementsList[0].unitary_price);
				}
			}
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getMonthlyRequestTemplates";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="name">Nume*</label>
						<InputText name="name" id="name" style={{"width":"100%"}} value={inputValues.name} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const listProductsDialog = () => {
		return(
			<Dialog header={dialogValues.titleListProducts} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openListProducts:false})} className="responsive-dialog-big">
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={12} md={4} lg={4} xl={4} className="field padding-med">
							<InputText name="filter_products" id="filter_products" style={{"width":"100%"}} value={inputValuesProducts.filter_products} placeholder="Cauta produs..." onChange={(evt) => handleChangeProducts(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="field padding-med">
							<Dropdown name="filter_product_type" id="filter_product_type" style={{"width":"60%","float":"left"}} filter options={dataValues.productsTypesList} placeholder="Filtrare categorie..." showClear optionLabel="name" optionValue="id" value={inputValuesProducts.filter_product_type} onChange={(evt) => handleChangeProducts(evt)}/>
							<div>
								<div style={{"width":"36%","float":"right","marginTop":"9px"}}>
									<Checkbox inputId="filter_invalid" name="filter_invalid" value="invalid"  onChange={(evt) => handleChangeProducts(evt)} checked={(inputValuesProducts.filter_invalid===1?true:false)}/>
									<label htmlFor="filter_invalid" className="ml-2">Doar fara contract</label>
								</div>
							</div>
						</Grid>						
						<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="field padding-med text-right">
							<Button label="Adauga produs" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add_product")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<DataTable
							id="centers_requests_products"
							value={templateProductsList}
							scrollable
							scrollHeight="60vh"
							style={{"minHeight":"63vh"}}
							scrollDirection="both"
							stripedRows
							resizableColumns
							rowGroupMode="rowspan"
							groupRowsBy="product_type"
							sortMode="single"
							sortField="product_type"
							sortOrder={1}
							rowClassName={rowClass}
							emptyMessage="Nu exista inregistrari"
						>
							<Column field="product_type" header="Tip produs" style={{"width":"21%","backgroundColor":"#FFFFFF"}} body={tableColTemplateProducts}></Column>
							<Column field="product_name" header="Produs" style={{"width":"36%"}}></Column>
							<Column field="sub_contract" header="Contract" style={{"width":"30%"}} body={tableColTemplateProducts}></Column>
							<Column field="buttons" header="" style={{"width":"195px"}} body={tableColTemplateProducts}></Column>
						</DataTable>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
			</Dialog>
		);
	}

	const addEditProductDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEditProduct} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_type_id">Categorie*</label>
						<Dropdown name="product_type_id" id="product_type_id" style={{"width":"100%"}} filter options={dataValues.productsTypesList} showClear optionLabel="name" optionValue="id" value={inputValuesProducts.product_type_id} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_id">Produs* ({productsList.length} produse gasite)</label>
						<Dropdown name="product_id" id="product_id" style={{"width":"100%"}} filter options={productsList} showClear optionLabel="name" optionValue="id" value={inputValuesProducts.product_id} onChange={(evt) => handleChangeProducts(evt)} disabled={(inputValuesProducts.product_type_id?false:false)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="product_mu_id">Unitate de masura*</label>
						<Dropdown name="product_mu_id" id="product_mu_id" style={{"width":"100%"}} options={dataValues.MUsList} filter value={inputValuesProducts.product_mu_id} optionLabel="name" optionValue="id" onChange={(evt) => handleChangeProducts(evt)} disabled={inputValuesProducts.product_id?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={8} lg={8} className="field padding-med text-right">
						<Button label="Cauta contract subsecvent" icon="pi pi-list" className="p-button-sm p-button-raised" style={{"marginTop":"24px"}} onClick={(evt) => handleButton(evt,"find_contract")} disabled={inputValuesProducts.product_id?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={8} lg={8} className="field padding-med">
						<label htmlFor="">Contract subsecvent*</label>
						<Dropdown name="sub_agreements_id" id="sub_agreements_id" style={{"width":"100%"}} options={dataValues.subAgreementsList} optionLabel="sub_agreement" optionValue="sub_agreement_id" value={inputValuesProducts.sub_agreements_id} onChange={(evt) => handleChangeProducts(evt)} disabled={dataValues.subAgreementsList.length>0?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} className="field padding-med">
						<label htmlFor="unitary_price">Pret unitar</label>
						<InputText name="unitary_price" id="unitary_price" pattern="[0-9.]*" style={{"width":"100%"}} value={unitaryPrice} disabled={dataValues.subAgreementsList.length>0?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} className="field padding-med">
						<label htmlFor="available_quantity">Cantitate</label>
						<InputText name="available_quantity" id="available_quantity" pattern="[0-9.]*" style={{"width":"100%"}} value={availableQuantity} disabled={dataValues.subAgreementsList.length>0?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValuesProducts.observations} onChange={(evt) => handleChangeProducts(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_product")} disabled={((inputError.disableSave)||(!inputValuesProducts.sub_agreements_id))}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza contract" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
					<Button label="Produse" icon="pi pi-list" tooltip="Produse" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"list_products",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge contract" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
				</span>
			);
		}
	}

	const tableColTemplateProducts = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza produs" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit_product",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge produs" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete_product",row_data)}/>
				</span>
			);
		}
		if(column.field==="product_type") {
			return(
				<div className="flex align-items-center gap-2">
					<span className="font-bold">{row_data.product_type}</span>
				</div>
			);
		}
		if(column.field==="sub_contract") {
			if((row_data.no)&&(row_data.agreement_date_parsed)&&(row_data.provider_name)) {
				return(
					<span>
						{row_data.no+"/"+row_data.agreement_date_parsed+" --- "+row_data.provider_name}
					</span>
				);
			}else{
				return(
					<span>
						<p>NU EXISTA CONTRACT ASOCIAT</p>
					</span>
				);
			}
		}				
	}

    const rowClass = (data) => {
		return {
            "no_contract": data.sub_agreements_id === 0
        };
    };

	const confirm = (evt,what,elementData) => {
		if((what==="delete")||(what==="delete_product")) {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={8} md={6} lg={6} xl={6} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{dataValues.templatesList.length} {(((dataValues.templatesList.length>1)||(dataValues.templatesList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={4} md={6} lg={6} xl={6} className="field padding-med text-right">
							<Button label="Adauga sablon" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={dataValues.templatesList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="name" header="Nume sablon" style={{"flexGrow":"1","flexBasis":"300px"}}></Column>
								<Column field="observations" header="Observatii" style={{"flexGrow":"1","flexBasis":"330px"}}></Column>
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"0","flexBasis":"180px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"285px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
				{dialogValues.openListProducts && listProductsDialog()}
				{dialogValues.openAddEditProduct && addEditProductDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default MonthlyRequestsTemplates;


